<template>
  <!-- src/plugins/vuetify.jsでコンポーネントを読み込み、propsの値によってアイコンを出し分けて使用する -->
  <span class="icon">
    <!-- AddIcon -->
    <img v-if="activeIcon === 'AddIcon'" src='../assets/svg/Add.svg'>

    <!-- CautionIcon -->
    <img v-if="activeIcon === 'CautionIcon'" src='../assets/svg/Caution.svg'>

    <!-- CloseIcon -->
    <img v-if="activeIcon === 'CloseIcon'" src='../assets/svg/Close.svg'>

    <!-- CheckIcon -->
    <img v-if="activeIcon === 'CheckIcon'" src='../assets/svg/Check.svg'>

    <!-- DirectoryBottomLayerIcon -->
    <img v-if="activeIcon === 'DirectoryBottomLayerIcon'" src='../assets/svg/DirectoryBottomLayer.svg'>

    <!-- DirectoryMinusIcon -->
    <img v-if="activeIcon === 'DirectoryMinusIcon'" src='../assets/svg/Directory_Minus.svg'>

    <!-- DirectoryPlusIcon -->
    <img v-if="activeIcon === 'DirectoryPlusIcon'" src='../assets/svg/Directory_Plus.svg'>

    <!-- SearchIcon -->
    <img v-if="activeIcon === 'SearchIcon'" src='../assets/svg/Search.svg'>

    <!-- SortAscIcon -->
    <img v-if="activeIcon === 'SortAscIcon'" src='../assets/svg/Sort1.svg'>

    <!-- SortDescIcon -->
    <img v-if="activeIcon === 'SortDescIcon'" src='../assets/svg/Sort2.svg'>
  </span>
</template>

<script>
export default {
  name: 'CustomIcon',
  props: ['activeIcon']
}
</script>

<style scoped>

.icon {
  display: flex;
  justify-content: center;
  align-items: center;
}

</style>
